<template>
  <el-table-column
    prop="is_service_billable"
    label="Szolgáltatás számlázandó"
    show-overflow-tooltip
    min-width="220"
    sortable="custom"
  >
    <template slot-scope="scope">
      {{ scope.row.is_service_billable ? 'Igen' : 'Nem' }}
    </template>
  </el-table-column>
</template>
<script>
  export default {
    propName: 'is_service_billable',
  };
</script>
